import { useQuery } from '@tanstack/react-query';

import { fetchRecipientDetail } from '../../../api/provisional/recipient-detail';
import { recipientDetailAvailable } from '../../../api/provisional/availability';
import { recipientKeys } from '../queries/keys';

// PROVISIONAL(Q-118) — server-state hook for the recipient dashboard.
// The fetcher lives in src/api/provisional/ (assumed contract:
// docs/provisional-contracts.md §1), so the swap to the real public endpoint
// never touches this hook's consumers. Disabled while the surface is
// unavailable so no request ever fires against a nonexistent endpoint.

export function useRecipientDetail(id) {
    return useQuery({
        queryKey: recipientKeys.detail(id),
        queryFn: ({ signal }) => fetchRecipientDetail(id, { signal }),
        enabled: recipientDetailAvailable && id != null,
    });
}
